import type { ISkillReferenceDTO } from '@sharedInterfaces/ISkill';
import { EIconCategory } from '@src/helper/iconRegistry';
import type Employee from '@src/Objects/Employee';
import React from 'react';

import FeatureCardWidget from './FeatureCardWidget';

interface SuperPowersCardWidgetProps {
    employee: Employee;
    onTabChange: (tabIndex: number) => void;
    currentSuperPowers?: ISkillReferenceDTO[];
    setCurrentSuperPowers?: React.Dispatch<React.SetStateAction<ISkillReferenceDTO[]>>;
}

function SuperPowersCardWidget({ employee, onTabChange }: SuperPowersCardWidgetProps) {
    return (
        <FeatureCardWidget
            title="SuperPowers"
            description="Entdecke und verwalte deine stärksten Fähigkeiten. Definiere bis zu 6 SuperPowers und setze deinen Fokus auf Skills der höchsten oder zweithöchsten Stufe."
            imagePath="/img/t4lo_superpowers.png"
            iconCategory={EIconCategory.SUPERPOWERS}
            onClick={() => onTabChange(2)}
        />
    );
}

export default SuperPowersCardWidget;
